<template>
  <div class="nav-header">
    <div class="container">
      <!-- logo -->
      <div class="n-logo">
        <h4>链意快修</h4>
        <!-- <img src="/imgs/logo.png" alt="" /> -->
        <!-- <h2>谜语网络</h2> -->
      </div>
      <!-- 右侧 -->
      <div class="n-r">
        <!-- 导航 -->
        <div class="n-list">
          <!-- <a href="/#/ac1" class="active">行业资讯</a> -->
          <!-- <a href="javascript:;" @click="goUs()">关于我们</a> -->
          <!-- <a href="javascript:;" @click="goSc()">产品展示</a> -->
          <!-- <a href="javascript:;" @click="goInfo()">新闻中心</a> -->
          <!-- <a href="javascript:;" @click="goCtm()">我的客户</a> -->
          <!-- <a href="javascript:;" >手机维修</a>
          <a href="javascript:;" >iPad维修</a>
          <a href="javascript:;" >笔记本维修</a>
          <a href="javascript:;" >家电维修</a>
          <a href="javascript:;" >家电清洗</a>
          <a href="javascript:;" >数码维修</a>
          <a href="javascript:;" >报价查询</a>
          <a href="javascript:;" >免费预约</a> -->
        </div>
        <!-- 联系方式 -->
        <div class="n-phone">
          <i class="iconfont icon-weibiaoti-"></i>
          400-107-8862
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-header",
  props: {
    href: String,
  },
  data() {
    return {};
  },
  methods: {
    // 关于我们跳转
    goUs() {
      this.$router.push("/ac2");
    },
    goSc() {
      this.$router.push("/ac1");
    },
    // 新闻跳转
    goInfo() {
      this.$router.push("/ac3");
    },
    goCtm() {
      this.$router.push("/ac4");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.nav-header {
  width: 100%;
  height: 80px;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  .container {
    height: 100%;
    @include flex();
    // border-bottom: 2px solid #000;
    // logo
    .n-logo {
      width: 200px;
      height: 100%;
      @include flex();
      // h4 {
      //   font-size: 21px;
      //   font-weight: 400;
      //   line-height: 50px;
      //   color: #ff430b
      // }
      img {
        width: 70%;
        height: 100%;
      }
      h4 {
        font-size: 21px;
        color: #ff430b;
        cursor: pointer;
      }
    }
    // 右侧
    .n-r {
      @include flex();
      height: 100%;
      // 导航
      .n-list {
        margin-right: 80px;
        .active {
          color: #ff430b;
        }
        a {
          font-size: 16px;
          color: #666;
          margin: 0 15px;
          transition: all 0.2s;

          &:hover {
            color: #ff430b;
          }
        }
      }
      // 联系方式
      .n-phone {
        font-size: 16px;
        color: #666;
        width: 150px;
        // transition: all .3s;
        cursor: pointer;
        &:hover {
          font-weight: bold;
          font-size: 18px;
          color: #ff430b;
        }
        i {
          font-size: 18px;
        }
      }
    }
  }
}
</style>
